import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ContentCopy from '@material-ui/icons/FileCopy';
import Share from '@material-ui/icons/Share';
import copy from 'copy-to-clipboard';
import React, { useState } from 'react';
import { useRedirect } from 'react-admin';
import {
  EmailIcon, ViberIcon, ViberShareButton, WhatsappIcon, WhatsappShareButton
} from "react-share";
import EmailShareButton from '../mail/EmailShareButton';





const DialogShare = (props, ...rest) => {
  const [open, setOpen] = useState(false);

  //const redirect = useRedirect();

  const {shareUrl,to} = props;
  const title = 'Facture : TLDI Logistique Services';

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <span>
      {/* Button to trigger the opening of the dialog */}
      <Button onClick={handleClickOpen} color="primary" startIcon={<Share />}>Partage</Button>
      {/* Dialog that is displayed if the state open is true */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {props.titre}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{textAlign:'center'}}>

          <Button
              label="Copier"
              color="primary"
              onClick={()=>copy(shareUrl)}
          >
          <ContentCopy />
          </Button>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            to={to ? to:''}
          
            >
            <EmailIcon size={32} round />
          </EmailShareButton>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>

          <ViberShareButton
            url={shareUrl}
            title={title}>
            <ViberIcon size={32} round />
          </ViberShareButton>
          
          
        </DialogActions>
      </Dialog>
    </span>
  );

}

export default DialogShare;
